import * as React from 'react'
import { toggleInArray } from '../../services/utils/utils.service'
import TooltipComponent from './tooltip.component'

interface Props<T> {
  name: string
  className?: string
  innerClassName?: string
  tooltipOnTruncate?: boolean
  truncateLabel?: boolean
  choices: { value: T, text: React.ReactElement | string, tooltip?: string, message?: string, disabled?: boolean }[]
  values: T[]
  onChange: (value: T[]) => void
}

export default function CheckboxGroupComponent<T> ({ choices, values, name, onChange, className, innerClassName, tooltipOnTruncate, truncateLabel = true }: Props<T>) {
  return <div className={ className }>
    { choices.map((choice, index) => <div key={ index } className={ `inputCheckbox ${ innerClassName ?? 'u-mbs' }` }>
      <input type="checkbox" checked={ values.includes(choice.value) } id={ `checkbox-group-${name}-${index}` } disabled={ choice.disabled } onChange={ () => !choice.disabled && onChange(toggleInArray(values, choice.value)) } />
      <label htmlFor={ `checkbox-group-${name}-${index}` }>
        { choice.tooltip && <TooltipComponent 
          message={ tooltipOnTruncate ? [<><strong>{ choice.text }</strong><br/> { choice.tooltip }</>] : choice.tooltip } 
          style={{ width: choice.tooltip ? 'calc(100% - 38px)' : '100%' }}
          children={ <span className={ truncateLabel ? 'u-txtTruncate' : '' }>{ choice.text }</span> } 
        /> }
        { !choice.tooltip && <div className="tooltip-container-module" style={{ width: 'calc(100% - 24px)' }}>
          <span className={ truncateLabel ? 'u-txtTruncate' : '' }>{ choice.text }</span>
        </div> }
      </label>

      { choice.message && <div className="inputRadio-message u-txtLight" style={{ whiteSpace: 'pre-line' }} children={ choice.message } /> }
    </div>) }
  </div>
}